
<ng-container *ngIf="isLoggedIn">
  <nav class="navbar navbar-expand-lg header-mainnav df-topnav mb-0 border-0 shadow-none">
    <div class="header-shell header-shell-main">
      <div class="topnav-brand-row">
        <div class="topnav-brand-left">
          <button class="navbar-toggler header-toggler" type="button" data-toggle="collapse" data-target="#nav2-content"
            aria-controls="nav2-content" [attr.aria-expanded]="isexpanded" aria-label="Toggle navigation"
            (click)="collapse()">
            <svg class="navbar-toggler-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
              <path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"
                d="M4 7h22M4 15h22M4 23h22" />
            </svg>
          </button>
          <a class="navbar-brand header-brand" href="javascript:void(0);">
            <img src="assets/amadeus-logo.png" alt="amadeus-logo">
          </a>
          <span class="navbar-brand header-title">eXternal Content Management</span>
        </div>

        <ul class="navbar-nav topnav-brand-actions">
          <li ngbDropdown class="nav-item">
            <button type="button" class="btn nav-link header-user" id="nav-user-dropdown" ngbDropdownToggle>
              <i class="fa fa-user me-1"></i>
              <span>{{userInfo?.login}}</span>
              <span *ngIf="userEnvironment" class="header-env-badge">{{ userEnvironment }}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="nav-user-dropdown" class="dropdown-menu dropdown-menu-end topbar-user-menu">
              <button ngbDropdownItem (click)="logout()" class="test-logout">
                <i class="fa fa-power-off fa-fw"></i> Logout
              </button>
            </div>
          </li>
        </ul>
      </div>

      <div [ngClass]="{'collapsed' : isexpanded, 'collapse': !isexpanded}" class="collapse navbar-collapse mainnav-collapse"
        id="nav2-content">
        <div class="topnav-menu-row">
          <ul class="navbar-nav mainnav-left">
        <ng-container *ngIf="scope$ | async as scope; else setuphome">
          <ng-container *ngIf="metagroup$ | async as metagroup">
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link" routerLink="/provider-profile/dashboard">
                Home <span class="sr-only">(current)</span>
              </a>
            </li>
          </ng-container>
        </ng-container>
        <ng-template #setuphome>
          <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link test-home" routerLink="/provider-profile/dashboard">
              Home <span class="sr-only">(current)</span>
            </a>
          </li>
        </ng-template>
 
        <li *ngIf="showProviderProfileForLocalValidation || (authorizations$ | async)?.R_PROFILE_TAB" class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link test-provider" routerLink="/provider-profile">
            Provider Profile
          </a>
        </li>

          </ul>

          <div class="mainnav-right">
            <div class="d-flex flex-row align-items-center flex-wrap header-context-wrap">
              <ng-container *ngIf="scope$ | async as scope">
                <ng-container *ngIf="metagroup$ | async as metagroup">
                  <span class="navbar-text header-context">
                    {{ scope?.description || scope.label }} <ng-container i18n>-</ng-container> {{ metagroup.label
                    }}
                  </span>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</ng-container>
